// extracted by mini-css-extract-plugin
export default {"confirm":"style_confirm__W0KT-","dialog":"style_dialog__Dwujh"};